if (!customElements.get('recommended-products')) {
  const chevron = `
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 34" width="100%" height="100%" viewBox="0 0 11.506 20.803">
      <defs>
          <clipPath id="9fubhk7wpa">
              <path data-name="Rectangle 17" style="fill: currentColor;" d="M0 0h11.506v20.803H0z"/>
          </clipPath>
      </defs>
      <g data-name="Group 21" style="clip-path:url(#9fubhk7wpa)">
          <path data-name="Path 15" d="m1.562 20.8 9.621-9.621a1.1 1.1 0 0 0 0-1.562L1.562 0 0 1.562 8.84 10.4 0 19.242z" style="fill:currentColor;"/>
      </g>
    </svg>
  `;
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.tileType = this.dataset.tileType || 'PDP';
      this.maxResults = this.dataset.max || 4
    }

    connectedCallback() {
      if (!this.productId) {
        this.closest('.product-recommended-products')?.classList.add('hidden');
        return;
      }

      fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${this.productId}`)
        .then(response => response.json())
        .then(({
          products
        }) => {
          const filteredProducts = products
            .filter((product) => !product.tags.find((tag) => tag === 'base_product' || tag === 'hide_product'));
          
          if (filteredProducts.length < 1) {
            this.closest('.shopify-section').classList.add('hidden');
            return;
          }
          if (this.tileType == 'PDP') {
            this.innerHTML = `
              <ul class="hidden md:grid grid-cols-4 gap-4">
                ${filteredProducts.slice(0, 4).map((product) => `
                  <li class="flex items-stretch">
                    <intersection-loader 
                      data-url="/products/${product.handle}" 
                      data-section-id="product-tile"
                    ></intersection-loader>
                  </li>
                `).join('')}
              </ul>
              <div class="relative z-[1]">
                <swiper-carousel
                  data-space-between="14"
                  data-slides-per-view-mobile="1.5"
                  class="w-full md:hidden"
                >
                  <div class="swiper-wrapper">
                    ${filteredProducts.slice(0, 4).map((product) => `
                      <div class="swiper-slide">
                        <intersection-loader 
                          data-url="/products/${product.handle}" 
                          data-section-id="product-tile"
                        ></intersection-loader>                    
                      </div>
                    `).join('')}
                  </div>
                  <div class="absolute -top-16 flex gap-3 right-0"> 
                    <button data-prev aria-label="Previous Slide" title="Previous Slide" class="button-small-slider">
                      <span aria-hidden="true" class="block h-3 transform -scale-x-100 w-2.5">
                        ${chevron}
                      </span>
                    </button>
                    <button data-next aria-label="Next Slide" title="Next Slide" class="button-small-slider">
                      <span aria-hidden="true" class="block h-3 w-2.5">
                        ${chevron}
                      </span>
                    </button>
                  </div>
                </swiper-carousel>
              </div>
            `;
          } else {
            this.innerHTML = `
            <ul class="flex flex-col gap-4">
                ${filteredProducts.slice(0, this.maxResults).map((product) => `
                  <li class="flex items-stretch rounded-lg bg-primaryLight p-4">
                    <intersection-loader 
                      data-url="/products/${product.handle}" 
                      data-section-id="quickbuy-widget"
                    ></intersection-loader>
                  </li>
                `).join('')}
              </ul>
            `
          }
        });
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}